import { Component } from "react";
import PropTypes from "prop-types";
import DotLoader from "components/utility/dot-loader/DotLoader";

class ButtonAction extends Component {
	static defaultProps = {
		disabled: false,
		onClick: () => void 0,
		width: "auto"
	};

	// TODO: remove dataACat, dataAAct, dataALbl
	// after other components get updated GA4 values
	static propTypes = {
		type: PropTypes.string,
		width: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		className: PropTypes.string,
		url: PropTypes.string,
		isButton: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
		buttonType: PropTypes.string,
		disabledOutline: PropTypes.string,
		disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
		isTarget: PropTypes.string,
		onClick: PropTypes.func,
		onKeyDown: PropTypes.func,
		isLoading: PropTypes.bool,
		dataA: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		dataACat: PropTypes.string,
		dataAAct: PropTypes.string,
		dataALbl: PropTypes.string,
		dataAEvt: PropTypes.string,
		dataALoc: PropTypes.string,
		dataAText: PropTypes.string,
		dataAComp: PropTypes.string,
		dataQa: PropTypes.string
	};

	constructor(props) {
		super(props);
		this.getType = this.getType.bind(this);
		this.getWidth = this.getWidth.bind(this);
		this.state = { isLoadingFlag: false };
	}
	componentDidUpdate(prevProps) {
		if (prevProps.isLoading && !this.props.isLoading) {
			this.setState({
				isLoadingFlag: false
			});
		}
	}
	getType() {
		switch (this.props.type) {
			case "outline":
				return "outline";
			case "outline-almost-black":
				return "outline-almost-black";
			case "solid":
				return "solid";
			case "solid-black-yellow":
				return "solid-black-yellow";
			case "solid-warm-yellow":
				return "solid-warm-yellow";
			default:
				return "outline";
		}
	}
	getWidth() {
		const width = this.props.width;
		let buttonWidthClass = "onethird";
		switch (width) {
			case "auto":
				buttonWidthClass = "auto";
				break;
			case "onethird":
				buttonWidthClass = "onethird";
				break;
			case "half":
				buttonWidthClass = "half";
				break;
			case "full":
				buttonWidthClass = "full";
				break;
			default:
				// auto width button
				buttonWidthClass = "auto";
				break;
		}
		return buttonWidthClass;
	}
	loadingIndicator = (e) => {
		if (typeof this.props.onClick === "function") {
			this.props.onClick(e);
		}
		this.setState({ isLoadingFlag: true });
	};
	render() {
		const {
			url = "",
			className = "",
			buttonType = "",
			label = "",
			isTarget = "",
			disabled,
			disabledOutline = "",
			onClick,
			onKeyDown,
			isLoading = false,
			dataALbl = "",
			dataACat = "",
			dataAAct = "",
			dataAEvt = "",
			dataALoc = "",
			dataAText = "",
			dataAComp = "",
			dataQa = ""
		} = this.props;
		const { isLoadingFlag } = this.state;

		let { isButton, downloadURL, dataA } = this.props;
		let loadingAction = isLoading && isLoadingFlag;
		let ga4props = {};
		if (typeof isButton === "string") {
			isButton = isButton === "true";
		}
		if (typeof dataA === "string") {
			dataA = dataA === "true";
		}
		if (dataA === "true" || dataA) {
			ga4props = {
				...(dataALbl && { "data-a-lbl": dataALbl }),
				...(dataACat && { "data-a-cat": dataACat }),
				...(dataAAct && { "data-a-act": dataAAct }),
				...(dataAEvt && { "data-a-evt": dataAEvt }),
				...(dataALoc && { "data-a-loc": dataALoc }),
				...(dataAText && { "data-a-text": dataAText }),
				...(dataAComp && { "data-a-comp": dataAComp })
			};
		}
		return isButton === "true" || isButton ? (
			<button
				className={
					"button-action" +
					" button-action-" +
					this.getType() +
					" button-action-" +
					this.getWidth() +
					(disabled === "true" || disabled === true
						? " button-action-disabled"
						: "" + (disabledOutline === "true" ? " button-action-disabled-outline" : "")) +
					(className ? " " + className : "")
				}
				type={buttonType ? buttonType : "button"}
				onClick={(e) => {
					this.loadingIndicator(e);
				}}
				onKeyDown={onKeyDown}
				aria-label={label}
				tabIndex="0"
				disabled={disabled === "true" || disabled === true}
				data-a={dataA}
				data-qa={dataQa}
				{...ga4props}
				data-testid="ButtonAction"
			>
				<div className="button-action-wrapper">
					<span
						className={"button-action-show" + (loadingAction ? " button-action-fading-out" : "")}
					>
						{label}
					</span>
					{isLoading ? (
						<span
							className={
								"button-action-hide button-action-loading" +
								(loadingAction ? " button-action-fading-in" : "")
							}
						>
							<DotLoader color="white" />
						</span>
					) : null}
				</div>
			</button>
		) : (
			<a
				href={url}
				className={
					"button-action" +
					" button-action-" +
					this.getType() +
					" button-action-" +
					this.getWidth() +
					(disabled === "true" || disabled === true
						? " button-action-disabled"
						: "" + (disabledOutline === "true" ? " button-action-disabled-outline" : "")) +
					(className ? " " + className : "")
				}
				target={isTarget === "true" ? "_blank" : "_self"}
				download={downloadURL ? "" : false}
				onClick={onClick}
				role="button"
				aria-label={label}
				tabIndex="0"
				rel={isTarget === "true" ? "noopener noreferrer" : ""}
				data-a={dataA}
				{...ga4props}
				data-qa={dataQa}
				data-testid="ButtonAction"
			>
				<div className="button-action-wrapper">
					<span
						className={"button-action-show" + (loadingAction ? " button-action-fading-out" : "")}
					>
						{label}
					</span>
					{isLoading ? (
						<span
							className={
								"button-action-hide button-action-loading" +
								(loadingAction ? " button-action-fading-in" : "")
							}
						>
							<DotLoader color="white" />
						</span>
					) : null}
				</div>
			</a>
		);
	}
}

export default ButtonAction;
